export default __webpack_public_path__ + "static/media/discover-log.92d31179.png";